<template>
  <div>
    <div class="cc-country">
        <div class="cc-country__header">
            <div class="cc-country__title cc-title cc-title--section">{{ translations['Country of delivery'] }}</div>
        </div>
        <div class="cc-country__main">
            <div class="cc-form-input">
                <select name="deliveryAddress.country" class="cc-input cc-input--select" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.country}" :value="user.deliveryAddress.country" @change="updateCountry">
                    <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                    <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.country">{{ user.errors.deliveryAddress.country }}</div>
            </div>
        </div>
        <div class="cc-country__mobile">
            <div class="cc-form-input">
                <select name="deliveryAddress.country" class="cc-input cc-input--select" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.country}" :value="user.deliveryAddress.country" @change="updateCountry">
                    <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                    <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.iso }}</option>
                </select>
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.country">{{ user.errors.deliveryAddress.country }}</div>
            </div>
        </div>
    </div>
      <div v-if="states && states.length" class="cc-country cc-country--states">
      <div class="cc-country__header">
        <div class="cc-country__title cc-title cc-title--section">{{ translations['State of delivery'] }}</div>
      </div>
      <div class="cc-country__main">
        <div class="cc-form-input">
          <select name="deliveryAddress.state" class="cc-input cc-input--select" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.state}" :value="user.deliveryAddress.state" @change="updateState">
            <option value="0" disabled="disabled">{{ translations['Select state'] }}</option>
            <option v-for="state in states" v-bind:key="state.id_state" :value="state.id_state">{{ state.name }}</option>
          </select>
          <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.state">{{ user.errors.deliveryAddress.state }}</div>
        </div>
      </div>
      <div class="cc-country__mobile">
        <div class="cc-form-input">
          <select name="deliveryAddress.country" class="cc-input cc-input--select" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.state}" :value="user.deliveryAddress.state" @change="updateState">
            <option value="0" disabled="disabled">{{ translations['Select state'] }}</option>
            <option v-for="state in states" v-bind:key="state.id_state" :value="state.id_state">{{ state.name }}</option>
          </select>
          <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.state">{{ user.errors.deliveryAddress.state }}</div>
        </div>
      </div>
      </div>

  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                user: state => state.user,
                countries: state => state.config.countries,
                defaultCountry: state => state.config.default_country,
                useDefaultCountry: state => state.config.use_default_country,
            }),
        },
        data: () => {
            return {
              states: [],
            };
        },
        watch: {
          'user.deliveryAddress.country': function (newVal, oldVal) {
            if (newVal !== oldVal) {
              this.fillStates()
            }
          }
        },
        methods: {
            updateCountry: function (event) {
                event.target.disabled = true;

                if (event.target.value === '') {
                    this.$store.dispatch('SELECT_CARRIER', null);
                    this.$store.dispatch('SELECT_PAYMENT', null);
                }

                var that = this;
                this.$store.dispatch('UPDATE_COUNTRY', event.target.value).then(function () {
                  event.target.disabled = false;
                  that.$store.dispatch('VALIDATE_WHOLE_FILLED_USER')
                  that.fillStates()
                });
            },
            updateState: function (event) {
              event.target.disabled = true;

              var that = this;
              this.$store.dispatch('UPDATE_STATE', event.target.value).then(function () {
                event.target.disabled = false;
                that.$store.dispatch('VALIDATE_WHOLE_FILLED_USER');
              });
            },
            fillStates: function () {
              let selectedCountry = this.countries.find(function (country) {
                return parseInt(country.id) === parseInt(this.user.deliveryAddress.country)
              }.bind(this));
              if (!selectedCountry || typeof selectedCountry === "undefined") {
                this.states = [];
                return;
              }
              this.states = selectedCountry.states
            }
        },
        mounted: function () {
          var that = this;
          if (!this.user.deliveryAddress.country && this.useDefaultCountry) {
            this.$store.dispatch('UPDATE_COUNTRY', this.defaultCountry)
                .then(() => {
                  that.fillStates()
                });
          } else {
            that.fillStates()
          }

        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/country";
    .cc-country--states {
      margin-top: .5rem;
      .cc-country__main {
        margin-top: 0;
      }
      .cc-country__header {
        margin-top: 0;
      }
    }
</style>
